
export const CERTIFICADO_EXTENSOES_PERMITIDAS = ['.pfx', '.p12'] as const;

export const CERTIFICADO_ACCEPT = '.pfx,.p12';

export const CERTIFICADO_TAMANHO_MAX_BYTES = 5_000_000;

export function obterExtensaoArquivo(nomeArquivo: string): string {
  const nome = (nomeArquivo || '').trim().toLowerCase();
  const idx = nome.lastIndexOf('.');
  if (idx < 0) return '';
  return nome.slice(idx);
}

export function isExtensaoCertificadoPermitida(nomeArquivo: string): boolean {
  const ext = obterExtensaoArquivo(nomeArquivo);
  return CERTIFICADO_EXTENSOES_PERMITIDAS.includes(ext as (typeof CERTIFICADO_EXTENSOES_PERMITIDAS)[number]);
}

export function validarArquivoCertificado(file: File | null | undefined): string | null {
  if (!file) {
    return 'Selecione um certificado digital A1 (.pfx ou .p12).';
  }

  if (!isExtensaoCertificadoPermitida(file.name)) {
    return 'Formato inválido. Use apenas certificado digital A1 nos formatos .pfx ou .p12.';
  }

  if (file.size <= 0) {
    return 'O arquivo do certificado está vazio. Selecione um arquivo .pfx ou .p12 válido.';
  }

  if (file.size > CERTIFICADO_TAMANHO_MAX_BYTES) {
    return 'O certificado excede o tamanho máximo de 5 MB.';
  }

  return null;
}
